const activePauses = new Set()

export function pauseSessionRevision() {
  const key = Symbol('session-revision-pause')
  activePauses.add(key)
  return () => activePauses.delete(key)
}

export function isSessionRevisionPaused() {
  return activePauses.size > 0
}
